import React, { useState } from "react";
import { Typography } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { cancelResetPasswordWatcher, resetPasswordWatcher } from "../../redux/actions/loginactioncreators";
import CognitoPasswordValidator from "../changePasswordForm/CognitoPasswordValidator";
import { TextField } from "../fields/TextField";
import { LoginFormExternalError, NewFADVLoginForm } from "./NewFADVLoginForm";
import { NewFADVPasswordField } from "../fields/NewFADVPasswordField";
const minPasswordLength = 8;
const validator = new CognitoPasswordValidator(minPasswordLength, 99, true, true, true, true);

export function NewFADVForgotPassword() {
    const dispatch = useDispatch();
    const username = useSelector(state => state.loginForm.username);
    const challenge = useSelector(state => state.loginForm.challenge);
    const accountNumber = useSelector(state => state.loginForm.accountNumber);
    const [passwordsMatch, setPasswordsMatch] = useState([true, false]);
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
    const [showErrors, setShowErrors] = useState(false);
    const handleCloseResetPassword = () => {
        dispatch(cancelResetPasswordWatcher());
    };

    const handleOnSubmit = (formData, errors) => {
        const { code, newPassword } = formData;
        if (errors && Object.keys(errors).length > 0) {
            // Do not dispatch if there are errors
            return;
        }
        dispatch(resetPasswordWatcher({
            step: "CONFIRM_RESET_PASSWORD",
            username: username.trim().toLowerCase(),
            code: code.trim(),
            password: newPassword.trim(),
            accountNumber: accountNumber?.trim(),
        }));
    };

    const checkPasswordsMatch = (formData, _errors) => {
        const { newPassword, newPasswordConfirm } = formData;
        setNewPassword(newPassword);
        setNewPasswordConfirm(newPasswordConfirm);
        setPasswordsMatch(newPassword && newPasswordConfirm && newPassword === newPasswordConfirm);
    }
    const handleNewPasswordBlur = () => {
        if (newPassword) {
            setShowErrors(true);
        }
    }

    const deliveryMedium = challenge?.challengeParameters?.CodeDeliveryDetails?.DeliveryMedium ?? "EMAIL";

    return (
        <NewFADVLoginForm
            onSubmit={handleOnSubmit}
            onChange={checkPasswordsMatch}
            requiredFields={["code", "newPassword", "newPasswordConfirm"]}
            showErrors={showErrors}
            secondaryButtonHandler={handleCloseResetPassword}
            secondaryButtonText={
                <FormattedMessage
                    id="login.cancel"
                    defaultMessage="Cancel"
                    description="Cancel button for forgot password dialog"
                />
            }
            headerText={
                <FormattedMessage
                    id="login.forgotPasswordTitle"
                    defaultMessage="Forgot your password?"
                    description="Title for forgot password dialog"
                />
            }
            submitButtonText={
                <FormattedMessage
                    id="login.resetPassword"
                    defaultMessage="Reset Password"
                    description="Submit button for forgot password dialog"
                />
            }
        >
            <LoginFormExternalError id="errorPasswordsDoNotMatch" show={newPassword && newPasswordConfirm && !passwordsMatch} error={
                <FormattedMessage
                    id="login.changePasswordPasswordsDoNotMatch"
                    defaultMessage="Passwords do not match"
                    description="Error message for password field"
                />
            }
            />
            {deliveryMedium === "SMS" &&
                <Typography>
                    <FormattedMessage
                        id="login.forgotPasswordSmsBlurb"
                        defaultMessage="A verification code has been sent via SMS to your registered mobile number. If you do not receive a verification code, please contact support at the number provided in the 'Contact Us' link below."
                        description="SMS instructions for forgot password dialog"
                    />
                </Typography>
            }
            {deliveryMedium === "EMAIL" &&
                <Typography>
                    <FormattedMessage
                        id="login.forgotPasswordEmailBlurb"
                        defaultMessage="A verification code has been sent to your registered email address. If you do not receive a verification code, please contact support at the number provided in the 'Contact Us' link below."
                        description="Email instructions for forgot password dialog"
                    />
                </Typography>
            }
            <TextField
                id="code"
                name="code"
                label={
                    <FormattedMessage
                        id="resetPassword.codeEntry"
                        defaultMessage="Verification Code"
                        description="Verification code field label for forgot password dialog"
                    />
                }
                autoFocus={true}
            />
            <NewFADVPasswordField
                id="newPassword"
                name="newPassword"
                label={
                    <FormattedMessage
                        id="login.forgotPasswordPlaceholder"
                        defaultMessage="Password (8 Minimum)"
                        description="New password field label for forgot password dialog"
                    />
                }
                passwordValidator={validator}
                onBlur={handleNewPasswordBlur}
            />
            <NewFADVPasswordField
                id="newPasswordConfirm"
                name="newPasswordConfirm"
                error={newPasswordConfirm && !passwordsMatch}
                label={
                    <FormattedMessage
                        id="resetPassword.passwordConfirm"
                        defaultMessage="Confirm Password"
                        description="Confirm password field label for forgot password dialog"
                    />
                }
            />
        </NewFADVLoginForm>
    );
}

NewFADVForgotPassword.propTypes = {
};